import moment from "moment-timezone";

moment.tz.setDefault(Intl.DateTimeFormat().resolvedOptions().timeZone);

export default moment;
